const information = {
  state: {
    //展示Loading
    loadingShow: false,
    // 添加乘机人列表
    passongerList: [],
    // 选择的地面产品信息及下单接口信息
    productOrderInfo: {},
    // 扫码页类型，boardingPass扫登机牌，paymentPay扫码支付
    scanType: "",
    // 扫码支付，调用支付参数
    payParameter: {},
  },
  mutations: {
    changeLoadingShow(state, isShow) {
      if (isShow === undefined) {
        state.loadingShow = !state.loadingShow;
      } else {
        state.loadingShow = isShow;
      }
    },
    changePassongerList(state, plist) {
      if (plist) {
        state.passongerList = plist;
      } else {
        state.passongerList = [];
      }
    },
    changeProductOrderInfo(state, orderInfo) {
      if (orderInfo) {
        state.productOrderInfo = orderInfo;
      } else {
        state.productOrderInfo = {};
      }
    },
    changeScanType(state, code) {
      if (code) {
        state.scanType = code;
      } else {
        state.scanType = "";
      }
    },
    changePayParameter(state, payInfo) {
      if (payInfo) {
        state.payParameter = payInfo;
      } else {
        state.payParameter = {};
      }
    },
  },
};
export default information;
